<template>
  <div class="checklist">
    <div class="container">
      <div class="row">
        <div class="col-6 project-name">
          Project:
          <input v-model.trim.lazy="project.name" @change="patch('replace', '/name', $event.target.value)" placeholder="Enter Project name" :disabled="readonly" />
        </div>
        <div class="col-3 project-type text-right">
          <label class="mr-1">Type:</label>{{ project.projectType | capitalize }}
        </div>
        <div class="col-3 text-right" v-if="isAdmin">
          <router-link v-if="!readonly" :to="{ name: 'manage-project', params: { projectId: project.id }}" class="btn btn-sm btn-outline-primary btn-edit-project ml-2">
            <LeadPencilIcon title="Edit Project" /> Edit
          </router-link>
          <b-button class="btn-remove-project ml-2" variant="outline-secondary" size="sm" @click="lockProject(project, !project.readonly)">
            <LockOpenVariantIcon v-if="project.readonly" title="Unlock Project" />
            <LockIcon v-else title="Lock Project" />
            {{project.readonly ? ' Unlock' : ' Lock'}}
          </b-button>
          <b-button class="btn-remove-project ml-2" variant="outline-warning" size="sm" @click="archiveProject(project, !project.archived)">
            <ArchiveArrowUpIcon v-if="project.archived" title="Unarchive Project" />
            <ArchiveIcon v-else title="Archive Project" />
            {{project.archived ? ' Unarchive' : ' Archive'}}
          </b-button>
        </div>
      </div>
      <div class="row my-2">
        <div class="col-12">
          <b-form-textarea class="project-description"
                           size="sm"
                           rows="2"
                           max-rows="10"
                           placeholder="Project Description"
                           v-model="project.description"
                           @change="patch('replace', '/description', $event)"
                           :readonly="readonly"></b-form-textarea>
        </div>
      </div>
      <div class="card">
        <div class="card-header p-2">
          <h5 class="d-inline">Checklists</h5>
          <b-button class="btn-add-checklist icon-btn float-right" variant="primary" size="sm" @click="showAddChecklists('Standard')" v-if="!readonly">
            <PlusBoxIcon /> Add Standard Checklist
          </b-button>
        </div>
        <div class="card-body">
          <div class="container-fluid">
            <div class="row summary-checklist-header">
              <div class="col-7"></div>
              <div class="col-2 text-center"># Issues</div>
              <div class="col-2 text-center">% Compl.</div>
              <div class="col-1 text-center">Hide</div>
            </div>
            <div class="row py-1 summary-checklist-row" v-for="checklist in standardChecklists" :key="checklist.id">
              <div class="col-7">
                <h5 v-if="checklist.hidden" class="d-inline">{{checklist.name}}</h5>
                <b-button  v-else variant="link" size="sm" @click="gotoChecklist(checklist)">
                  <h5 class="d-inline">{{checklist.name}}</h5><ClipboardCheckIcon class="ml-2" v-if="checklist.signOffAt" :size="38" fillColor="#28a745" title="Signed Off"></ClipboardCheckIcon>
                </b-button>
              </div>
              <div class="col-2 text-center" v-if="checklist.status">
                <b-badge :variant="checklist.status.issue ? 'danger' : 'secondary'" @click="$emit('goto-issues', '')">
                  {{checklist.status.issue}}
                </b-badge>
              </div>
              <div class="col-2 text-center" v-if="checklist.status">

                {{checklist.status.accepted / checklist.status.count | numeral('0%')}}
                <b-progress height="6px" class="" :max="checklist.status.count">
                  <b-progress-bar :value="checklist.status.accepted" variant="success"></b-progress-bar>
                </b-progress>
              </div>
              <div class="col-1 text-center">
                <b-button class="btn-remove-project ml-2" :variant="checklist.hidden ? 'primary' : 'outline-primary'" size="sm" @click="hideChecklist(checklist, !checklist.hidden)">
                  <ClipboardTextOffIcon v-if="checklist.hidden" title="Restore Checklist" />
                  <ClipboardEditIcon class="" v-else title="Hide Checklist" />
                </b-button>
              </div>
            </div>
            <!-- <div class="row summary-row pt-1">
            <div class="col-7"></div>
            <div class="col-2 text-center">
              <b-badge :variant="project.status.issue ? 'danger' : 'secondary'"  @click="$emit('goto-issues', '')">{{project.status.issue}}</b-badge>
            </div>
            <div class="col-2 text-center">
              {{project.status.accepted / project.status.count | numeral('0%')}}
              <b-progress height="6px" class="" :max="project.status.count">
                <b-progress-bar :value="project.status.accepted" variant="success"></b-progress-bar>
              </b-progress>
            </div>
            <div class="col-1"></div>
          </div> -->
          </div>
        </div>
      </div>
    </div>

    <AddRepeatChecklist ref="AddStdChecklistModal" 
                        :project="project" 
                        :checklistType="ChecklistType.Standard" 
                        :forceSuffix="false" 
                        @add-checklist="saveRepeatChecklist">
    </AddRepeatChecklist>
  </div>
</template>

<script>
  import Vue from "vue";
  import { mapGetters } from "vuex";

  import { Client, Operation, ChecklistType } from "../code/EngineeringChecklist.Api";
  import { InitializeChecklist } from "../code/Initializers"

  import AddRepeatChecklist from "./modals/AddRepeatChecklist.vue"

  import PlusBoxIcon from 'vue-material-design-icons/PlusBox.vue';
  import LeadPencilIcon from 'vue-material-design-icons/LeadPencil.vue';
  import ArchiveIcon from 'vue-material-design-icons/Archive.vue';
  import ArchiveArrowUpIcon from 'vue-material-design-icons/ArchiveArrowUp.vue';
  import LockIcon from 'vue-material-design-icons/Lock.vue';
  import LockOpenVariantIcon from 'vue-material-design-icons/LockOpenVariant.vue';
  import ClipboardTextOffIcon from 'vue-material-design-icons/ClipboardTextOff.vue';
  import ClipboardEditIcon from 'vue-material-design-icons/ClipboardEdit.vue';
  import ClipboardCheckIcon from 'vue-material-design-icons/ClipboardCheck.vue';

  export default Vue.extend({
    name: "ProjectSummary",
    components: {
      AddRepeatChecklist,
      PlusBoxIcon,
      LeadPencilIcon,
      ArchiveIcon, ArchiveArrowUpIcon,
      LockIcon, LockOpenVariantIcon,
      ClipboardTextOffIcon, ClipboardEditIcon,
      ClipboardCheckIcon
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
    props: {
      project: { type: Object, required: true },
      readonly: { type: Boolean, required: true }
    },
    data() {
      return {
        ChecklistType,
        patches: [],
        loading: false,
        templatesLoaded: false,
        repetitiveTemplates: [],
        addChecklistDialog: {
          visible: false,
          selectedTemplateId: null,
          type: 'Standard',
          newName: ''
        },
        selectedTemplate: null
      };
    },
    computed: {
      ...mapGetters('context', ['isAdmin']),
      standardChecklists: function () {
        return _.sortBy(_.filter(this.project.checklists, { type: ChecklistType.Standard }) || [], ['sortOrder']);
      }
    },
    methods: {
      patch: function (op, path, value) {

        //Only allow updates to the readonly flag
        if (this.readonly && path && path.indexOf('readonly') == -1) {
          return;
        }


        let patch = _.find(this.patches, { op: op, path: path });

        if (patch) {
          patch.value = value;
        } else {
          patch = new Operation({ op: op, path: path, value: value });
          this.patches.push(patch);
        }
      },
      processProjectPatches: function () {


        if (this.patches && this.patches.length) {
          var c = new Client(process.env.VUE_APP_API_URL, this.$http);

          c.checklistProjects_Patch(this.project.id, this.patches)
            .then(function (updatedProject) {
              if (updatedProject) {
                delete updatedProject.checklists;
                Object.assign(this.project, updatedProject);
              }
              this.patches = [];
            }.bind(this))
            .catch(function (error) {
              this.$bvToast.toast(error.message, {
                title: `Saving ${this.project.name} failed`,
                variant: "danger"
              });
            })
        }
      },
      patchChecklist: function (checklist, patch) {
        if (!checklist || !checklist.id) {
          console.log('Invalid checklist, cannot be patched');
          return;
        }
        var c = new Client(process.env.VUE_APP_API_URL, this.$http);
        var patches = [
          patch
        ]

        return c.checklists_Patch(checklist.id, patches)
          .then(function (updatedChecklist) {
            if (updatedChecklist) {
              delete updatedChecklist.areas;
              Object.assign(checklist, updatedChecklist);
            }
          }.bind(this))
          .catch((error) => {
            console.log(error);
          })
      },
      gotoChecklist(checklist) {
        setTimeout(function () {
          this.$emit('goto-checklist', checklist)
        }.bind(this), 250);
      },
      lockProject(project, locked) {

        this.$bvModal.msgBoxConfirm(`Are you sure you want to ${locked ? 'lock' : 'unlock'} project ${project.name}?`, {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(function (value) {

          if (value) {
            this.patch('replace', '/readonly', !!locked);
          }
        }.bind(this))
      },
      archiveProject(project, archived) {

        this.$bvModal.msgBoxConfirm(`Are you sure you want to ${archived ? 'archive' : 'unarchive'} project ${project.name}?`, {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'warning',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(function (value) {

          if (value) {
            this.patch('replace', '/archived', !!archived);
          }
        }.bind(this))


      },
      hideChecklist(checklist, hidden) {

        //checklist.hidden = hidden;

        //this.$bvModal.msgBoxConfirm(`Are you sure you want to ${hidden ? 'hide' : 'restore'} checklist '${checklist.name}'?`, {
        //  title: 'Please Confirm',
        //  size: 'sm',
        //  buttonSize: 'sm',
        //  okVariant: 'warning',
        //  okTitle: 'YES',
        //  cancelTitle: 'NO',
        //  footerClass: 'p-2',
        //  hideHeaderClose: false,
        //  centered: true
        //}).then(function (value) {
        //  if (value) {
        //  }
        //}.bind(this))

        this.patchChecklist(checklist, new Operation({ op: 'replace', path: '/hidden', value: !!hidden }));
          //.then(function () {
          //  this.$bvToast.toast(`Sucessfully ${hidden ? 'hid' : 'restored'} checklist: '${checklist.name}'`, {
          //    title: `Checklist ${hidden ? 'Hidden' : 'Restored'}.`,
          //    variant: "success"
          //  });
          //}.bind(this));

      },
      repeatTemplateSelected: function (mechId) {
        let mechTemplate = _.find(this.repetitiveTemplates, { id: mechId });

        if (mechTemplate) {

          let prefix = mechTemplate.name.replace(/.?template/gi, ''),
            suffix = '',
            siblingCount = _.reduce(this.standardChecklists, function (total, item) {
              if (item.name && item.name.startsWith(prefix)) {
                total += 1;
              }
              return total;
            }, 0);

          if (siblingCount) {
            suffix = String(siblingCount + 1).padStart(2, '0');
          }

          this.addChecklistDialog.newName = `${prefix} ${suffix}`;
        }

      },
      showAddChecklists: function () {
        this.$refs['AddStdChecklistModal'].show()
      },
      saveRepeatChecklist: function (addOpts) {
        var c = new Client(process.env.VUE_APP_API_URL, this.$http);

        c.repetitiveChecklists_CopyChecklistToProject(
          addOpts.templateId, this.project.id, addOpts.name, addOpts.checklistType)
          .then(function (newChecklist) {

            InitializeChecklist(newChecklist);

            this.project.checklists.push(newChecklist);

            this.gotoChecklist(newChecklist);

          }.bind(this))
          .catch((error) => {
            console.log(error);
          })
      },
    },
    watch: {
      patches: function (newValue, oldValue) {
        if (newValue && newValue.length) {
          this.debouncedProcessProjectPatches();
        }
      },
    },
    created() {
      this.debouncedProcessProjectPatches = _.debounce(this.processProjectPatches, 1500, {
        leading: false,
        trailing: true
      });
    }
  });
</script>

<style lang="scss">
  .project-name {
    font-size: 1.6em;
    font-weight: bold;
    width: 100%;
  }
  .project-type {
    font-size: 1.125em;
    font-weight: bold;
  }
  .summary-checklist-header,
  .summary-checklist-row {
    border-bottom: 1px dashed #DDD;

    &:last-child {
      border-bottom: 0;
    }

    &:hover {
      background-color: #EFEFEF;
    }

    button {
      //color: #333;

      h5 {
        margin: 0.2em 0 0;
      }

      &:hover {
        //color: midnightblue;
        font-weight: bold;
        //text-decoration: none;
      }
    }
  }


  // .summary-row {
  //   border-top: 3px solid #BBB;
  // }
</style>